var ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    MetadataList          = require("./MetadataList"),
    PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    PopupLayout           = require("app/AppLayout/PopupLayout"),
    ScrollerPopup         = require("app/ui/ScrollerPopup"),
    closeButtonThemeVars  = require("app/theme/IconButtonVariables--close"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    get                   = require("object-path").get,
    kind                  = require("enyo/kind"),
    themeVars             = require("app/theme/variables.js"),
    utils                 = require("enyo/utils");

require("./DescriptionPopup.less");
require("app/theme/IconButton--negative.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");

module.exports = kind(/** @lends  app.ui.header.DescriptionPopup.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.DescriptionPopup",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment:           "fullLayout",
        expand:              false,
        overlapSafeArea:     false,
        clearFloatingHeader: true,

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx()
                + (this.container.get("showCloseButton")
                    ? closeButtonThemeVars.getIconSize() / 2
                    : 0);
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @private
     */
    classes: "app-ui-header-description-popup",

    /**
     * @public
     */
    theme: "bordered",

    /**
     * @private
     */
    captureEvents: true,

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:       "description",
        classes:    "app-ui-header-description-popup__description",
        components: [{
            name:    "title",
            tag:     "h2",
            classes: "app-ui-header-description-popup__title"
        }, {
            name:    "secondaryTitle",
            tag:     "h3",
            classes: "app-ui-header-description-popup__secondary-title"
        }, {
            name:      "body",
            allowHtml: true,
            classes:   "app-ui-header-description-popup__body"
        }, {
            name:    "metadata",
            kind:    MetadataList,
            classes: "app-ui-header-description-popup__metadata"
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.updateAndResize);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService     = this.app.$.i18nService,
            data            = this.data || {},
            secondaryTitle  = get(data, "meta.secondary_title", null),
            metadata        = [],
            artists         = get(data, "artists", []),
            year            = get(data, "year", null),
            $secondaryTitle = this.$.secondaryTitle;

        this.$.title.set("content", get(data, "meta.title", null) || "");

        if (secondaryTitle) {
            $secondaryTitle.set("content", secondaryTitle);
            $secondaryTitle.show();
        }
        else {
            $secondaryTitle.hide();
        }

        this.$.body.set("content", get(data, "meta.html_long_description", null) || "");

        if (artists.length > 0 && artists.join(", ") !== secondaryTitle) {
            if (artists.length === 1) {
                metadata.push({
                    id:    utils.uid(),
                    label: i18nService.getString("app.ui.header.MetadataListItem.artist"),
                    value: artists[0]
                });
            }
            else {
                metadata.push({
                    id:    utils.uid(),
                    label: i18nService.getString("app.ui.header.MetadataListItem.artists"),
                    value: artists.join(", ")
                });
            }
        }

        if (year !== null) {
            metadata.push({
                id:    utils.uid(),
                label: i18nService.getString("app.ui.header.MetadataListItem.year"),
                value: year
            });
        }

        this.$.metadata.set("data", metadata);
    }

});
